import dayjs from "../utils/dayjs";
import { RandomCode } from "./Method";

import { useAppContext } from "context";

export default function Model() {
  const { selCompany, bizContext } = useAppContext();
  const ctx = { outletId: bizContext?.outletId || "", companyId: selCompany };

  const JVMdl = () => ({
    id: "",
    isPosted: false,
    title: "",
    type: 1,
    status: "",
    ledgerId: "",
    ...ctx,

    voucherDate: new Date().toISOString(),
    voucherNumber: "",
    reference: "",
    remarks: "",
    docs: [],
    docsFiles: [],
    lines: [
      {
        id: "",
        key: Date.now(),
        chartOfAccountId: "",
        debit: "",
        credit: "",
        particulars: "",
        balanceType: "",
      },
      {
        id: "",
        key: Date.now() + 1,
        chartOfAccountId: "",
        debit: "",
        credit: "",
        particulars: "",
        balanceType: "",
      },
    ],
    // Not Mapped
    isBalanced: true,
    difference: 0,
    totalDebit: 0,
    totalCredit: 0,
    jvAuditTrail: {
      action: "",
      comment: "",

      // Default set
      toStatus: 1,
      fromStatus: 1,
    },
  });

  const BizContextMdl = () => ({
    orgId: "",
    companyId: "",
    outletId: "",
  });

  const LoginMdl = () => ({
    username: "",
    password: "",
  });

  const InvItemCountedMdl = () => {
    return {
      id: "",
      invCountId: "",
      invCountItemId: "",
      expected: "",
      counted: "",
      ...ctx,
    };
  };

  const InvCountMdl = () => {
    return {
      id: "",
      startDate: "",
      startTime: "",
      countName: "",
      countType: 1,
      includeInactiveProds: false,
      items: [],
      ...ctx,
    };
  };

  const FiscalYearMdl = () => ({
    id: "",
    title: "",
    notes: "",
    startDate: "",
    endDate: "",
    fiscalYearDocs: [],
    ...ctx,
  });

  const SnapshotMdl = () => ({
    id: "",
    type: 5,
    fiscalYearId: "",

    fromDate: "",
    toDate: "",

    notes: "",

    totalSales: "",
    totalReturns: "",
    netRevenue: "",
    cogs: "",
    grossProfit: "",
    totalExpenses: "",
    netProfit: "",

    closingInventoryValue: "",
    closingInventoryCount: "",

    TotalReceivables: "",
    TotalPayables: "",

    TotalTaxCollected: "",
    TotalTaxPaid: "",
    TotalDiscount: "",
    ...ctx,
  });

  const PassResetMdl = () => ({
    userId: "",
    newPassword: "",
    confirmPassword: "",
    ...ctx,
  });

  const FollowUpMdl = () => ({
    id: 0,
    followUpDate: "",
    followUpTime: "",
    followUpTypeId: "",
    note: "",
    ...ctx,
  });

  const LedgerMdl = () => ({
    id: 0,
    name: "",
    ledgerType: "",
    accountingStandard: "",
    currencyId: "",
    companyId: "",

    isActive: true,
    isDefault: false,

    startDate: new Date().toISOString(),
    endDate: "",

    orgId: "",
    createdAt: new Date().toDateString(),
    createUserId: "",

    updatedAt: "",
    lastUpdatedUser: "",
  });

  const AddressBookMdl = () => ({
    line1: "",
    line2: "",
    city: "",
    state: "",
    postalCode: "",
    country: "",
  });

  const CompanyMdl = () => ({
    id: 0,
    businessType: 0,
    name: "",
    legalName: "",
    regNumber: "",
    tinOrVatRegNo: "",
    timeZoneId: "",

    defaultLedgerId: "",
    defaultCurrencyId: "",

    writeOffLimit: "",
    enableAuthCode: false,
    journalVoucherAutoPost: false,

    useSimpleStockDocNumbering: false,
    stockOrderNoStart: 1000,
    stockReturnNoStart: 1000,
    inventoryAdjustmentNoStart: 1000,
    stockTransferNoStart: 1000,

    isActive: true,
    email: "",
    telephone: "",
    mobile: "",
    website: "",
    socialMedia: "",
    registeredAddress: AddressBookMdl(),
    sameAsRegAddress: false,
    mailingAddress: AddressBookMdl(),

    initialLedger: LedgerMdl(),

    logo: "",
    logoFile: "",

    orgId: "",
    createAt: new Date().toISOString(),
    createUserId: "",

    updatedAt: "",
    lastUpdateUserId: "",
  });

  const PrintLabelMdl = () => ({
    id: "",
    printType: 1,
    items: [],

    showOutlet: true,
    showSku: true,
    showProdTitle: true,
    showRtlPrice: true,
    showMadeIn: false,

    outletName: "",

    createDate: new Date().toISOString(),
    ...ctx,
  });

  const StockTransferMdl = () => ({
    id: "",
    refNo: "",
    transferDate: new Date().toISOString(),

    fromLocationId: "",
    toLocationId: "",

    remarks: "",

    items: [],

    ...ctx,
  });

  const InvAdjustmentMdl = () => ({
    id: "",
    adjustmentNo: "",
    adjustmentDate: new Date().toISOString(),
    adjustmentType: 1,
    reason: 2,
    note: "",
    adjustmentItems: [],
    totalQty: 0,
    totalAmount: 0,
    ...ctx,
  });

  const SellReturnMdl = () => ({
    id: "",
    sellId: "",
    returnItems: [],
    refundAmt: 0,
    refundTaxAmt: 0,
    discAdj: 0,
    payableRefund: 0,
    storeCredit: "",
    refundMethods: [],
    returnDate: new Date().toISOString(),
    ...ctx,
  });

  const DirectReturnMdl = () => ({
    id: "",
    customerId: "",
    returnItems: [],
    refundAmt: 0,
    refundTaxAmt: 0,
    discAdj: 0,
    storeCredit: "",
    refundMethods: [],
    isDirectReturn: true,
    returnDate: new Date().toISOString(),
    ...ctx,
  });

  const CustomerTxnMdl = () => ({
    id: "",
    isPaid: "",
    sellType: "",
    txnType: "",
    sellId: "",
    paySellIds: "",
    customerId: "",
    cashierId: "",
    registerId: "",
    orgId: "",
    amount: "",
    payTypeId: "",
    userNote: "",
    referenceNo: "",
    createdAt: new Date().toISOString(),
    ...ctx,
  });

  const SupplierTxnMdl = () => ({
    id: "",
    isPaid: "",
    txnType: "",
    stockId: "",
    supplierId: "",
    txnUserId: "",
    orgId: "",
    amount: "",
    payTypeId: "",
    userNote: "",
    referenceNo: "",
    writeOffRemaining: false,
    writeOffReason: "",
    payStockIds: "",
    createDate: new Date().toISOString(),
    ...ctx,
  });

  const SellRegisterMdl = () => ({
    id: 0,

    registerId: "",
    userId: "",

    cashInDrawer: "",
    openingNotes: "",
    openingTime: "",

    cashMovement: 0,
    closingTime: "",
    closingNotes: "",
    closingFloat: 0,
    cashReceived: "",
    sellRegPayments: [],
    ...ctx,
  });

  const CoaMdl = () => ({
    id: 0,
    code: "",
    name: "",

    accountType: "",
    accountCategory: "",
    normalBalance: "",

    isActive: true,
    isPostable: true,
    isFrozen: false,

    parentAccountId: "",
    level: 0,

    ledgerId: "",
    companyId: "",
    currencyId: "",

    effectiveFrom: new Date().toUTCString(),
    effectiveTo: "",

    description: "",
    openingBalance: "",
    openingBalanceType: "",
    rowVersion: "",
  });

  const AccountMappingMdl = () => ({
    id: 0,
    isActive: true,
    mappingType: "",
    accountId: "",
    ledgerId: "",
    companyId: "",
    orgId: "",
    effectiveFrom: new Date().toUTCString(),
    effectiveTo: "",
    rowVersion: "",
  });

  const ChgPassMdl = () => ({
    oldPass: "",
    password: "",
    confirmPass: "",
  });

  const RegisterMdl = () => ({
    id: 0,
    orgId: "",
    userId: "",
    name: "",
    emailReceipt: false,
    printReceipt: true,
    enableSound: true,
    accountId: "",
    ...ctx,
  });

  const SellMdl = () => ({
    id: 0,
    status: 2,
    type: "",

    sellItems: [],
    taxAmt: 0,
    taxRate: 0,
    taxId: "",
    disAmt: "",
    discount: "",
    disType: 1,
    subtotal: 0,
    totalItems: 0,
    netPayable: 0,
    received: "",
    change: "",
    note: "",
    customerId: "",
    customerVehicleId: "",
    customerVehicle: null,
    employeeId: "",
    employee: null,
    payments: [],
    sellDate: new Date().toISOString(),
    quoteSaleId: "",

    // Promotion engine denormalised fields (populated by POS coupon input
    // + server-side FinalizeRedemptionsAsync)
    couponCode: "",
    couponDiscountAmt: 0,
    autoDiscountAmt: 0,
    promotionTotalAmt: 0,

    // Optional auth code (e.g. card terminal authorization). Captured only
    // when Company.EnableAuthCode is ON; printed on the receipt when set.
    authCode: "",

    // Cash Sales Invoice — walk-in capture + header extras. Null on POS sales.
    walkInMobile: "",
    walkInCivilId: "",
    walkInName: "",
    walkInAddress: "",
    walkInArea: "",
    refNo: "",
    priceTier: 1, // Retail by default; matches EnumLi.PriceTier
    invoiceNo: "",

    ...ctx,
  });

  const OrgMdl = () => ({
    // Org Info.
    id: 0,
    name: "",
    defaultTaxId: "",
    currencyId: "",
    logo: "",
    logoFile: "",
    description: "",
    uiTemplate: "classic",

    address: {
      line1: "",
      line2: "",
      city: "",
      state: "",
      postalCode: "",
      country: "",
    },
  });

  const CashMgmtMdl = () => ({
    id: "",
    txnType: 1,
    amount: "",
    note: "",
    txnDate: "",
    expenseTypeId: "",
    ...ctx,
  });

  const RefundMdl = () => ({
    id: "",
    prodCond: 1,
    invoiceId: "",
    note: "",
    ...ctx,
  });

  const CartProdMdl = () => ({
    qty: "",
    price: "",
    discount: "",
    note: "",
  });

  const ServiceMdl = () => ({
    id: 0,
    cstmrId: "",
    phone: "",
    email: "",
    date: "",
    hours: "",
    minutes: "",
    note: "",
    ...ctx,
  });

  const ServiceItemMdl = () => ({
    id: 0,
    name: "",
    localName: "",
    skuCode: "",
    desc: "",
    serviceCategoryId: "",
    price: "",
    cost: "",
    isOpenPrice: false,
    minPrice: "",
    taxId: "",
    durationMinutes: "",
    img: "",
    imgFile: "",
    isActive: true,
    ...ctx,
  });

  const ServiceCategoryMdl = () => ({
    id: 0,
    name: "",
    desc: "",
    img: "",
    imgFile: "",
    isActive: true,
    ...ctx,
  });

  const EmployeeMdl = () => ({
    id: 0,
    fullName: "",
    phone: "",
    email: "",
    photo: "",
    photoFile: "",
    jobTitle: "",
    department: "",
    hireDate: "",
    salary: "",
    nationalId: "",
    emergencyContact: "",
    userId: "",
    outletId: "",
    isActive: true,
    ...ctx,
  });

  const ServiceBayMdl = () => ({
    id: 0,
    name: "",
    desc: "",
    isActive: true,
    ...ctx,
  });

  const ServiceDiscountTypeMdl = () => ({
    id: 0,
    name: "",
    discountPercent: "",
    isActive: true,
    ...ctx,
  });

  const QuoteMdl = () => ({
    id: 0,
    customerId: "",
    phone: "",
    email: "",
    note: "",
    ...ctx,
  });

  const UserMdl = () => ({
    id: 0,
    fullName: "",
    email: "",
    phone: "",

    username: "",
    outletPermissions: [],
    companyPermissions: [],
    roleId: "",
    crudProfileId: "",
    reportProfileId: "",
    privilegeProfileId: "",
    restrictToOwnRecords: false,
    recordVisibleFrom: "",
    password: "",
    confirmPass: "",

    dailyTarget: "",
    weeklyTarget: "",
    monthlyTarget: "",

    gender: "",
    dob: "",
    address1: "",
    address2: "",
    city: "",
    state: "",
    zip: "",

    photo: "",
    photoFile: "",
    defaultLang: 1,

    createUser: new Date().toISOString(),
  });

  const BankAccountMdl = () => ({
    id: 0,
    accountName: "",
    bankName: "",
    accountNumber: "",
    iban: "",
    branchCode: "",
    isDefault: false,
    isActive: true,
    chartOfAccountId: "",
    currencyId: "",
    ...ctx,
  });

  const BankReconciliationMdl = () => ({
    id: 0,
    bankAccountId: "",
    statementEndDate: new Date().toISOString().split("T")[0],
    statementEndingBalance: 0,
    beginningBalance: 0,
    serviceCharge: 0,
    serviceChargeAccountId: "",
    interestEarned: 0,
    interestEarnedAccountId: "",
    status: "Draft",
    notes: "",
    ...ctx,
  });

  const PayTypeMdl = () => ({
    id: 0,
    name: "",
    getway: "",
    askForReference: false,
    bankAccountId: "",
    accountId: "",
    ...ctx,
  });

  const TaxMdl = () => ({
    id: 0,
    name: "",
    rate: "",
    createDate: new Date().toISOString(),
    ...ctx,
  });

  const CityMdl = () => ({
    id: 0,
    name: "",
  });

  const OutletMdl = () => ({
    id: 0,
    outletName: "",
    timeZone: "",
    taxId: "",
    phone: "",
    email: "",
    regName: "",

    address1: "",
    address2: "",
    city: "",
    state: "",
    zip: "",

    // POS Settings
    posTemplate: 1,

    // Receipt Settings
    receiptType: 1,
    paymentReceiptType: 1,
    registerReceiptType: 2,
    expenseReceiptType: 1,
    receiptWidth: 58,
    showLogoOnReceipt: false,
    showOutletNameOnReceipt: true,
    showAddressOnReceipt: true,
    showPhoneOnReceipt: true,
    showEmailOnReceipt: false,
    showTaxOnReceipt: true,
    bilingualReceipt: false,
    allowPosPriceEdit: false,
    enableEmployeeOnSale: false,
    salesTerms: "",
    ...ctx,
  });

  const CstmrGroupMdl = () => ({
    id: 0,
    name: "",
    desc: "",
    createDate: new Date().toISOString(),
    ...ctx,
  });

  const CstmrMdl = () => ({
    id: 0,
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    gender: "",
    cstmrGroupId: "",
    dob: "",
    openingBalance: "",

    cityId: "",
    state: "",
    zip: "",
    address1: "",
    address2: "",

    cstmrCode: "",
    company: "",

    website: "",
    twitter: "",
    note: "",
    photo: "",
    photoFile: "",
    accBalType: "",
    balLimit: "",
    taxId: "",

    // Credit Terms
    isCreditEnabled: false,
    creditDays: "",
    creditLimit: "",

    // card details
    nameOnCard: "",
    cardNumber: "",
    expiryDate: "",
    securityCode: "",

    createDate: new Date().toISOString(),
    ...ctx,
  });

  const StockMdl = () => ({
    id: 0,
    supplierId: "",
    orderingFor: [],
    recipientOutletId: "",
    supplierInvoice: "",
    deliveryDate: dayjs().add(3, "day").toISOString(),
    orderNum: RandomCode(12),
    stockProducts: [],
    isReceived: false,
    note: "",
    type: "",

    // Accounts
    subtotal: "",
    discountType: 2,
    discount: "0.00",
    // Not mapped
    discountAmount: "0.00",
    totalItemDisAmt: 0,
    shippingFee: "",
    importDuty: "",
    totalOrderAmount: "",

    createdAt: new Date().toISOString(),
    ...ctx,
  });

  const ReceivedDeliveryMdl = () => ({
    id: 0,
    supplierId: "",
    orderingFor: [],
    recipientOutletId: "",
    supplierInvoice: "",
    deliveryDate: new Date().toISOString(),
    orderNum: RandomCode(12),
    stockProducts: [],
    note: "",

    // Accounts
    subtotal: "",
    discountType: 2,
    discount: "0.00",
    // Not mapped
    discountAmount: "0.00",
    totalItemDisAmt: 0,
    shippingFee: "",
    importDuty: "",
    totalOrderAmount: "",
    ...ctx,
  });

  const SpecialOrderMdl = () => ({
    id: 0,
    cstmrId: "",
    phone: "",
    email: "",
    deliveryDate: "",
    note: "",
    ...ctx,
  });

  const StockReturnMdl = () => ({
    id: 0,
    orderNo: "",
    stockId: "",
    userId: "",
    stockReturnItems: [],
    keepRefundAsCredit: false,
    totalQty: "",
    totalAmount: "",
    returnDate: new Date().toISOString(),
    createdAt: new Date().toISOString(),
    note: "",
    ...ctx,
  });

  const ReturnStockMdl = () => ({
    id: 0,
    returnNo: "",
    deliveryDue: new Date().toISOString(),
    deliveryTo: "",
    returnForm: "",
    nameOrRefe: `Return - ${new Date().toDateString()}`,
    supplierInvoice: "",
    files: [],
    returnFiles: [],
    ...ctx,
  });

  const StockTransMdl = () => ({
    id: 0,
    fromOutlet: "",
    toOutlet: "",
    refe: `Stock Transfer 1225 - ${new Date().toDateString()}`,
    date: "",
    ...ctx,
  });

  const SupplierMdl = () => ({
    id: 0,
    splrName: "",
    defMarkup: "",
    openingBalance: "",
    desc: "",
    supplierCompany: "",

    // Credit Terms
    isCreditEnabled: false,
    creditDays: "",
    creditLimit: "",

    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    fax: "",
    gender: "",
    website: "",

    address1: "",
    address2: "",
    country: "",
    city: "",
    state: "",
    zip: "",

    photo: "",
    photoFile: "",
    createDate: new Date().toISOString(),
    ...ctx,
  });

  const CategoryMdl = () => ({
    id: 0,
    name: "",
    desc: "",
    parentCatId: "",
    isMainCat: true,
    img: "",
    imgFile: "",
    createDate: new Date().toISOString(),
    ...ctx,
  });

  const ExpenseTypeMdl = () => ({
    id: 0,
    title: "",
    subtitle: "",
    accountId: "",
    createDate: new Date().toISOString(),
    ...ctx,
  });

  const ExpenseMdl = () => ({
    id: 0,
    txnDate: new Date().toISOString(),
    expenseTypeId: "",
    payTypeId: "",
    remarks: "",
    amount: "",
    createDate: new Date().toISOString(),
    ...ctx,
  });

  const BrandMdl = () => ({
    id: 0,
    name: "",
    desc: "",
    createDate: new Date().toISOString(),
    ...ctx,
  });

  // ---------- Promotion engine ----------
  const PromotionMdl = (kind = 1) => ({
    id: 0,
    code: "",
    name: "",
    description: "",
    promoKind: kind, // 1 = Coupon, 2 = AutoDiscount
    rewardType: 1, // 1=Percentage, 2=FixedAmount, 3=Bogo, 4=TieredSpend
    rewardValue: 0,
    maxDiscountCap: "",
    appliesTo: 1, // 1=CartTotal, 2=LineItem, 3=CheapestMatchingItem, 4=SpecificProducts
    buyQty: "",
    getQty: "",
    getRewardType: "",
    getRewardValue: "",
    startAt: new Date().toISOString().slice(0, 16),
    endAt: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toISOString().slice(0, 16),
    priority: 100,
    isExclusive: false,
    canStackWithManualDiscount: true,
    canStackWithOtherPromotions: false,
    usageLimitTotal: "",
    usageLimitPerCustomer: "",
    usageLimitPerDay: "",
    requiresApproval: false,
    approvalThresholdPercent: "",
    isActive: true,
    conditions: [],
    tiers: [],
    bogoRules: [],
    companyId: ctx.companyId || 0,
    orgId: ctx.orgId || 0,
  });

  const PromotionConditionMdl = () => ({
    id: 0,
    conditionType: 1,
    operator: 1,
    refEntityId: "",
    valueDecimal: "",
    valueInt: "",
    valueString: "",
    valueJson: "",
  });

  const PromotionTierMdl = () => ({
    id: 0,
    minAmount: 0,
    rewardType: 1,
    rewardValue: 0,
    sortOrder: 0,
  });

  const PriceCategoryMdl = () => ({
    id: 0,
    name: "",
    ...ctx,
  });

  const TagMdl = () => ({
    id: 0,
    name: "",
    desc: "",
    createDate: new Date().toISOString(),
    ...ctx,
  });

  const ForgotMdl = () => ({
    email: "",
    forgotStep: "",
    verCode: "",
    password: "",
    confirmPass: "",
  });

  const ProdMdl = () => ({
    id: 0,
    name: "",
    localName: "",
    brandId: "",
    prodTags: [],
    catId: "",
    subCatId: "",
    desc: "",
    madeIn: "",

    taxId: "",
    taxPrice: "",
    prodSuppliers: [],
    splrCode: "",
    splrPrice: "",
    markup: "",
    minRtlPrice: "",
    rtlPrice: "",
    priceType: 1,
    retailPrices: [],

    trackInv: true,
    inventories: [],

    // Multi-Unit
    baseUnitId: "",
    productUnits: [],

    prodType: 1,
    skuCode: "",
    skuType: 1,

    // Variant Product
    prodVariants: [],
    prodVarAttrs: [{ id: 1, attrId: "", value: [] }],

    // Composit Product
    compositProds: [],

    imgs: [],
    imgFiles: [],

    createDate: new Date().toISOString(),
    ...ctx,
  });

  const VariantProdMdl = () => ({
    // Not Mapped
    key: 0,

    id: 0,
    splrCode: "",
    splrPrice: "",
    minRtlPrice: "",
    rtlPrice: "",
    skuType: 1,
    skuCode: "",
    enabled: true,

    taxId: "",
    taxPrice: "",

    attrId1: "",
    attrVal1: "",
    attrId2: "",
    attrVal2: "",
    attrId3: "",
    attrVal3: "",

    inventories: [],

    imgs: [],
    imgFiles: [],
  });

  const FollowUpTypeMdl = () => ({
    id: 0,
    name: "",
  });

  const InqSrcMdl = () => ({
    id: 0,
    name: "",
  });

  const InquiryMdl = () => ({
    id: 0,
    fullName: "",
    phone: "",
    inqSrcId: "",
    remark: "",

    email: "",
    address: "",
    subsTypeId: "",
    subsPlanId: "",
    inqDate: "",

    userId: "",
  });

  const CurrencyMdl = () => ({
    id: 0,
    symbol: "",
    shortName: "",
    fullName: "",
    currencyUnit: "",
    allowDecimal: 2,
    createDate: "",
    lastUpdate: "",
    createUserId: "",
    lastUpdateUserId: "",
    orgId: "",
    ...ctx,
  });

  const UserRoleMdl = () => ({
    id: "",
    title: "",
    subtitle: "",
    accessType: 0,
    featuresAccess: "",
    ...ctx,
  });

  const AccountTransferMdl = () => ({
    id: 0,
    fromAccountId: "",
    toAccountId: "",
    amount: "",
    note: "",
    transferDate: new Date().toISOString().split("T")[0],
    ...ctx,
  });

  const UnitCategoryMdl = () => ({
    id: 0,
    name: "",
    desc: "",
    ...ctx,
  });

  const UnitMdl = () => ({
    id: 0,
    name: "",
    abbreviation: "",
    unitCategoryId: "",
    baseConversionFactor: 1,
    isBaseUnit: false,
    ...ctx,
  });

  const CommissionPlanMdl = () => ({
    id: 0,
    name: "",
    period: 1,
    tierMode: 1,
    deductVoidReturns: false,
    isActive: true,
    // 1 = Product, 2 = Service, 3 = Both. Default Both.
    targetTierScope: 3,
    applyToAllProducts: false,
    allProductCommission: "",
    allProductRateType: 2,
    applyToAllServices: false,
    allServiceCommission: "",
    allServiceRateType: 2,
    tiers: [],
    itemRates: [],
    ...ctx,
  });

  const CommissionReportFilterMdl = () => ({
    employeeId: "",
    fromDate: "",
    toDate: "",
    ...ctx,
  });

  return {
    JVMdl,
    InvItemCountedMdl,
    PassResetMdl,
    UserRoleMdl,
    CurrencyMdl,
    InquiryMdl,
    InqSrcMdl,
    FollowUpTypeMdl,
    PrintLabelMdl,
    CompanyMdl,
    LoginMdl,
    ChgPassMdl,
    ForgotMdl,
    ProdMdl,
    CategoryMdl,
    SupplierMdl,
    BrandMdl,
    StockMdl,
    ReturnStockMdl,
    StockTransMdl,
    CstmrMdl,
    CstmrGroupMdl,
    OutletMdl,
    PayTypeMdl,
    TaxMdl,
    CityMdl,
    UserMdl,
    CartProdMdl,
    QuoteMdl,
    ServiceMdl,
    ServiceItemMdl,
    ServiceCategoryMdl,
    ServiceDiscountTypeMdl,
    EmployeeMdl,
    ServiceBayMdl,
    CashMgmtMdl,
    SellMdl,
    SpecialOrderMdl,
    StockReturnMdl,
    RefundMdl,
    OrgMdl,
    TagMdl,
    VariantProdMdl,
    ReceivedDeliveryMdl,
    RegisterMdl,
    SellRegisterMdl,
    CustomerTxnMdl,
    SellReturnMdl,
    DirectReturnMdl,
    SupplierTxnMdl,
    FollowUpMdl,
    InvCountMdl,
    ExpenseMdl,
    ExpenseTypeMdl,
    FiscalYearMdl,
    SnapshotMdl,
    LedgerMdl,
    CoaMdl,
    AccountMappingMdl,
    StockTransferMdl,
    InvAdjustmentMdl,
    BizContextMdl,
    PriceCategoryMdl,
    AccountTransferMdl,
    BankAccountMdl,
    BankReconciliationMdl,
    UnitCategoryMdl,
    UnitMdl,
    CommissionPlanMdl,
    CommissionReportFilterMdl,
    PromotionMdl,
    PromotionConditionMdl,
    PromotionTierMdl,
  };
}
